@file:OptIn(InternalResourceApi::class)

package com.example.hukakmp.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.example.hukakmp.resources/"

@delegate:ResourceContentHash(379_089_144)
public val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_897_299_801)
public val Res.drawable.huka_logo: DrawableResource by lazy {
      DrawableResource("drawable:huka_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/huka_logo.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("huka_logo", Res.drawable.huka_logo)
}
